/**
 * Остання дія, яку можна скасувати клавішею (`Ctrl+Z` / `⌘Z` поза полями; UX-14, UX-15): тост
 * «Скасувати» живе 5 с, а клавіша — ще до кінця вікна `ttlMs` блоку `undo` відповіді (60 с).
 * Модуль першого екрана без залежностей: дію кладе лінивий чанк (видалення), клавішу слухає оболонка
 * (`LifecycleKeys` в оболонці). Одна дія: нова заміщує попередню, скасована — забувається.
 */

interface LastUndo {
  run: () => void;
  expiresAt: number;
}

let last: LastUndo | null = null;

/** Запам'ятати дію для `Ctrl+Z` до `Date.now() + ttlMs`. */
export function rememberUndo(run: () => void, ttlMs: number): void {
  last = { run, expiresAt: Date.now() + ttlMs };
}

/** Забути дію: її вже скасовано тостом чи вона більше не чинна. */
export function forgetUndo(run: () => void): void {
  if (last?.run === run) last = null;
}

/** Скасувати останню дію, якщо вікно не минуло; `false` — скасовувати нічого. */
export function runLastUndo(now = Date.now()): boolean {
  const current = last;
  last = null;
  if (!current || now > current.expiresAt) return false;
  current.run();
  return true;
}

/** Для тестів: стан модуля між тестами. */
export function resetUndoForTests(): void {
  last = null;
}
